import ms from 'ms'

import ToastNotice from '@components/toast/ToastNotice'
import useSnooze from '@hooks/useSnooze.ts'
import useTypedTranslation from '@hooks/useTypedTranslation.ts'
import { useBackendVersion, VERSION } from '@state/version.ts'

function NewVersionToast() {
  const { t } = useTypedTranslation()
  const { data: versionInfo } = useBackendVersion()
  const { isSnoozed, snooze } = useSnooze()

  if (!versionInfo) return null
  if (!versionInfo.version) return null

  const backendVersion = versionInfo.version

  const shouldShowToast = VERSION !== backendVersion && !isSnoozed

  return (
    <ToastNotice
      id={`new-version-${backendVersion}`}
      open={shouldShowToast}
      onOpenChange={(open) => {
        if (!open) {
          snooze(ms('5min'))
        }
      }}
      title={t('common.newVersion.title')}
      description={t('common.newVersion.description')}
      variant="info"
      action={{
        label: t('common.newVersion.action'),
        onAction: () => window.location.reload(),
      }}
      duration={Infinity}
    />
  )
}

export default NewVersionToast